import mapWhite from "./IconPlan.png";
import map from "./map_24px_dark.png";

type MapIconProps = {
  color?: string;
};

const MAP_IMAGES: Record<string, string> = {
  dark: map,
  white: mapWhite,
};

export const MapIcon = ({ color }: MapIconProps) => (
  <img src={MAP_IMAGES[color || "dark"]} alt="Map icon" />
);
